import { toast } from '@loopreturns/sonik/toast';
import { createStore } from 'vuex';

import shopsApi from '@/controllers/shopsController';
import { formatJson } from '@/helpers/formatters';

const toBoolean = (value) => {
  // If is yes/no, cast to boolean
  if (typeof value === 'string' && ['yes', 'no'].includes(value)) {
    return value === 'yes';
  }

  return value;
};

export const store = createStore({
  state: {
    userData: null,
    shops: [],
    shopData: null,
    notes: null,
    deviants: null,
    language: 'en',
    returnData: null,
    returnSearchResults: null,
    token: null,
  },
  mutations: {
    // update order state and save to local storage
    updateData: function (state, data) {
      const options = {
        name: data.name || false, // required
        data: data.data !== undefined ? data.data : false,
        save: data.save || false,
      };

      state[options.name] = options.data;

      if (options.save) {
        localStorage.setItem(options.name, JSON.stringify(options.data));
      }
    },
    setProperty (state, { key, value }) {
      state[key] = value;
    },
    clearData (state, name) {
      if (localStorage.getItem(name)) {
        localStorage.removeItem(name);
      }

      if (state[name]) {
        state[name] = null;
      }
    },
    setReturn (state, data) {
      data.shopSettings = formatJson(data.shop.settings, 'key');
      state.returnData = data;
    },
    updateShops (state, newShop) {
      state.shops.push(newShop);
    },
  },
  actions: {
    // To add shops in an "onboarding" state to enable app store download
    async addNewShop (context, { newShopName, newShopShopifyDomain }) {
      const request = {
        name: newShopName,
        state: 'onboarding',
        nonce: 'dummy',
        provider_domain: newShopShopifyDomain,
      };
      try {
        const newShop = await shopsApi.addShop(request);
        toast.success({
          detail: 'Shop added successfully. The shop will appear in the list above once they have completed onboarding.',
        });
        context.commit('updateShops', newShop);
      } catch (error) {
        toast.error({ detail: error.response.data.message });
      }
    },
  },
  getters: {
    settings (state) {
      // Create an object of settings so we can access settings by key
      if (state.shopData && state.shopData.settings) {
        return state.shopData.settings.reduce((accumulator, current) => {
          return {
            ...accumulator,
            [current.key]: {
              data: current,
              value: toBoolean(current.value),
            },
          };
        }, {});
      }
      return {};
    },
    getSetting: (_state, getters) => (setting) => {
      return getters.settings[setting] ? getters.settings[setting].value : null;
    },
  },
});
